import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Individual, Meta, PaginationLink } from 'utils';

interface IndividualsResponse {
    data: Individual[];
    links: PaginationLink;
    meta: Meta;
}

type ReturnType = Promise<AxiosResponse<IndividualsResponse>>;

const getIndividuals = (params = {}): ReturnType => {
    return Request.get(`/individuals`, {
        params,
    });
};

export default getIndividuals;
